import React, { useState, useEffect } from "react";

const Vender = () => {
  const [qst, setQst] = useState([
    {
      qst: "¿Es seguro vender mi arte en el marketplace?",
      ans: "SI. Gracias al blockchain y a los smart contracts auditados ofrecemos una seguridad inquebrantable. ",
    },
    {
      qst: "¿Se puede pagar o cobrar con criptomonedas? ¿Y con FIAT?",
      ans: "SI. Gracias al blockchain y a los smart contracts auditados ofrecemos una seguridad inquebrantable. ",
    },
    {
      qst: "¿Existe algún tipo de coste adicional para un artista?",
      ans: "SI. Gracias al blockchain y a los smart contracts auditados ofrecemos una seguridad inquebrantable. ",
    },
  ]);

  const Questions = ({ data }) => {
    const [open, setOpen] = useState(false);
    return (
      <div className="item flex flex-col">
        <div className="qst flex aic justify-between">
          <div className="qst-lbl">{data.qst}</div>
          <div className="ico cursor-pointer" onClick={(e) => setOpen(!open)}>
            {open ? (
              <img src="./images/minusIcon.svg" className="img" />
            ) : (
              <img src="./images/PlusIcon.svg" className="img" />
            )}
          </div>
        </div>
        <div className={`ans ${open ? "open" : ""}`}>
          SI. Gracias al blockchain y a los smart contracts auditados ofrecemos
          una seguridad inquebrantable.
        </div>
      </div>
    );
  };
  return (
    <div className="vender-page flex flex-col">
      <div className="hero-sec flex aic jc">
        <div className="hero-sec-desc">
          nunca ha sido tan fÁcil crear
          <br /> posicionar y vender tus obras de
          <br /> arte en formato NFT
        </div>
      </div>
      <div className="vender-sec-b flex flex-col">
        <div className="vender-b-wrap wrapWidth flex-col">
          <div className="sec-b-desc">
            Cuenta con nuestro apoyo integal en la creación, posicionamiento y
            venta de tus obras de arte y colecciones en el mundo NFT.
            <br />
            <span>
              Ofrecemos el servicio más completo para artistas en el mercado
              NFT.
            </span>
          </div>
          <div className="what-do flex flex-col">
            <div className="what-do-tag">¿Qué hacemos?</div>
            <div className="what-do-block">
              <div className="what-do-card flex flex-col ">
                <img src="./images/nft-21.svg" className="img" />
                <div className="card-dec">
                  Convertimos obras de arte en NFTs, las alojamos y
                  posicionamos.
                </div>
              </div>
              <div className="what-do-card flex flex-col ">
                <img src="./images/ventas1.svg" className="img" />
                <div className="card-dec">
                  Impulsamos las ventas de galerías y artistas a nivel mundial.
                </div>
              </div>
              <div className="what-do-card flex flex-col ">
                <img src="./images/tierra1.svg" className="img" />
                <div className="card-dec">
                  Ofrecemos un servicio integral de creación y venta de NFTs y
                  colecciones.
                </div>
              </div>
            </div>
          </div>
          <div className="choise-sec flex flex-col">
            <div className="choise-tag">¿Por qué somos tu mejor opción?</div>
            <div className="choise-wrap">
              <div className="choise-card flex aic">
                <div className="numb">01.</div>
                <div className="dec">
                  <span>Tranquilidad:</span> nos ocupamos del asesoramiento,
                  creación de smart contracts y NFTs, subida de NFTs,
                  posicionamiento, gestión de ventas y cobros.
                </div>
              </div>
              <div className="choise-card flex aic">
                <div className="numb">02.</div>
                <div className="dec">
                  <span>Seguridad:</span> seleccionamos cada NFT y artista de
                  manera individual, todos los NFTs están auditados. No existen
                  replicas de tus NFTs.
                </div>
              </div>
              <div className="choise-card flex aic">
                <div className="numb">03.</div>
                <div className="dec">
                  <span>Control:</span> controlamos todo el proceso de subida y
                  venta para una mejor experiencia pera el artista y
                  compradores.
                </div>
              </div>
              <div className="choise-card flex aic">
                <div className="numb">04.</div>
                <div className="dec">
                  <span>Posicionamiento y atracción de clientes:</span>{" "}
                  empleamos las últimas herramientas y estrategias para la
                  atracción de clientes.
                </div>
              </div>
              <div className="choise-card flex aic">
                <div className="numb">05.</div>
                <div className="dec">
                  <span>Respaldo:</span> asesoramiento integral y formación
                  permanente para la conceptualización de NFTs y ventas de los
                  mismos.
                </div>
              </div>
              <div className="choise-card flex aic">
                <div className="numb">06.</div>
                <div className="dec">
                  <span>Especialización:</span> somos un marketplace
                  especializado el mundo del arte con un equipo altamente
                  cualificado.
                </div>
              </div>
            </div>
            <div className="action flex aic jc">
              <button className="btn cleanbtn button">
                Contacte con nosotros para obtener más información.{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="apply flex aic jc flex-col">
        <div className="apply-tag">
          Únete a nuestra comunidad de
          <br /> artistas profesionales
        </div>
        <div className="btn button">Aplicar ahora</div>
      </div>
      <div className="wrok-type flex flex-col">
        <div className="wrap wrapWidth flex">
          <div className="left flex">
            <div className="bgImage flex aic jc">
              <div className="tag">Tipos de obras</div>
            </div>
          </div>
          <div className="right flex">
            <div className="right-blk">
              <div className="work-card flex aic">
                <img src="./images/wk1.svg" className="img" />
                <div className="lbl">Arte digital</div>
              </div>
              <div className="work-card flex aic">
                <img src="./images/wk2.svg" className="img" />
                <div className="lbl">Pintura</div>
              </div>
              <div className="work-card flex aic">
                <img src="./images/wk3.svg" className="img" />
                <div className="lbl">Escultura</div>
              </div>
              <div className="work-card flex aic">
                <img src="./images/wk4.svg" className="img" />
                <div className="lbl">Fotografía</div>
              </div>
              <div className="work-card flex aic">
                <img src="./images/wk5.svg" className="img" />
                <div className="lbl">Vídeo</div>
              </div>
              <div className="work-card flex aic">
                <img src="./images/wk6.svg" className="img" />
                <div className="lbl">Realidad virtual</div>
              </div>
              <div className="work-card flex aic">
                <img src="./images/wk7.svg" className="img" />
                <div className="lbl">Libros</div>
              </div>
              <div className="work-card flex aic">
                <img src="./images/wk8.svg" className="img" />
                <div className="lbl">
                  Obras <br />
                  tokenizadas
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="how-sale flex flex-col">
        <div className="wrap wrapWidth flex flex-col">
          <div className="tag">¿Cómo vender tu arte en el mercado NFT?</div>
          <div className="desc">
            Trabajamos por y para tu tranquilidad. Cuentas con nuestro respaldo
            en todo el proceso.
          </div>
          <div className="steps">
            <div className="setp-card flex flex-col aic">
              <img src="./images/numb1.svg" className="numb-img" />
              <div className="step-tag">Proceso de selección y filtrado</div>
              <div className="step-desc">
                Nuestro equipo, cuenta con un riguroso procedimiento de filtrado
                y selección de artistas y obras para ofrecer a nuestros
                compradores los mejores NFTs de arte.{" "}
              </div>
            </div>
            <div className="setp-card flex flex-col aic">
              <img src="./images/numb2.svg" className="numb-img" />
              <div className="step-tag">Subida de NFTs al marketplace</div>
              <div className="step-desc">
                Para tu tranquilidad, nosotros nos oscupamos de todo. Subimos
                tus NFTs con todos sus atributos e información consiguiendo
                mayores posibilidades de venta.
              </div>
            </div>
            <div className="setp-card flex flex-col aic">
              <img src="./images/numb3.svg" className="numb-img" />
              <div className="step-tag">Creación de Smart Contracts</div>
              <div className="step-desc">
                Nuestro equipo, configura el smart contract de manera
                profesional recogiendo todas las caractristicas y beneficios que
                aporta cada NFT al comprador.
              </div>
            </div>
            <div className="setp-card flex flex-col aic">
              <img src="./images/numb4.svg" className="numb-img" />
              <div className="step-tag">Venta de NFTs y gestión de cobros</div>
              <div className="step-desc">
                Gestionamos la venta de manera integral, desde la venta hasta la
                gestión de pagos en cripto o FIAT al propietario de la obra.
              </div>
            </div>
          </div>
          <div className="action flex aic jc">
            <div className="btn button">Quiero subir mis obras en NFTs</div>
          </div>
        </div>
      </div>
      <div className="slider flex flex-col jc">
        <div className="wrap wrapWidth flex">
          <div className="left flex jc flex-col">
            <img src="./images/logo.svg" className="logo-img" />
            <div className="numbs">4,7/5</div>
            <div className="lbl">Excelente</div>
          </div>
          <div className="center flex flex-col aic jc">
            <img src="./images/auth_users.png" className="user-img" />
            <div className="name">@autor</div>
          </div>
          <div className="right flex aic jc">
            <div className="box flex flex-col">
              <div className="box-hder flex justify-between">
                <div className="tag">La mejor elección</div>
                <div className="box-numbs flex aic jc">5/5</div>
              </div>
              <div className="box-desc">
                NFTsTotal.art es una excelente plataforma para comprar y vender
                NFT. Tiene una interfaz fácil de usar y es uno de los
                marketplaces más confiables para NFT. También ofrece funciones
                innovadoras, que la convierte en una excelente opción para
                cualquiera que busque entrar al mercado de NFT.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="faqs-sec flex flex-col">
        <div className="wrap wrapWidth flex flex-col">
          <div className="faq-tag">Preguntas frecuentes</div>
          <div className="faqs-blk flex flex-col">
            {qst.map((item, index) => (
              <Questions data={item} />
            ))}
          </div>
        </div>
      </div>
      <div className="faqs-sallers flex flex-col">
        <div className="wrap wrapWidth flex flex-col">
          <div className="tag">Consulta nuestras FAQs para vendedores</div>
        </div>
      </div>
    </div>
  );
};

export default Vender;
